<script setup lang="ts">
import type { Knowledge } from 'shared/src'
import { OCardAdvanced, ODropdown, OInputLabel } from '@ai/ui-components'

const { t } = useI18n()

const modelValue = defineModel<Knowledge>({ required: true })

import { useKnowledgeApi } from '@/composables/api/useKnowledgeApi.ts'

const { documentOptions } = useKnowledgeApi()

const selectedDocuments = computed({
  get: () => modelValue.value.document_ids ?? [],
  set: (val: string[]) => {
    modelValue.value.document_ids = val
  },
})
</script>

<template>
  <div class="flex flex-col space-y-6">
    <OCardAdvanced
      elevation="S"
      border-radius="XL"
      content-class="border border-neutral-5"
      inline
      :title="t('knowledge')"
      :subtitle="t('select_documents_from_knowledge_base')"
    >
      <div class="col-span-2 flex flex-col space-y-6">
        <OInputLabel
          :props="{
            label: t('select_documents'),
          }"
        />
        <ODropdown
          v-model="selectedDocuments"
          :options="documentOptions"
          :placeholder="t('select_documents_placeholder')"
          multi-select
          searchable
          dataTestid="knowledge-documents-select"
        />
      </div>
      <VariableMentionInput
        v-model="modelValue.custom_output"
        :label="t('custom_output.label')"
        class="col-span-2"
        dataTestid="knowledge-output"
      />
      <VariableMentionInput
        v-model="modelValue.custom_output_unsuccessful"
        :label="t('custom_output_unsuccessful.label')"
        class="col-span-2"
        dataTestid="knowledge-output-unsuccessful"
      />
    </OCardAdvanced>
  </div>
</template>
